import React from "react";
import type { DialogProps, ModalOverlayProps } from "react-aria-components";
import { Modal as AriaModal, Dialog, DialogTrigger } from "react-aria-components";

import { cn } from "@/lib/helpers/cn";
import { CloseButton } from "../atoms/CloseButton";
import { ModalOverlay2 } from "../atoms/ModalOverlay";

function ModalBase({ children, ...dialogProps }: DialogProps) {
  return (
    <ModalOverlay2>
      <AriaModal className={styles.modal}>
        <Dialog {...dialogProps} className={cn(styles.dialog)}>
          {children}

          <CloseButton className={styles.close} slot="close" />
        </Dialog>
      </AriaModal>
    </ModalOverlay2>
  );
}

type ModalProps = DialogProps & {
  trigger: React.ReactElement;
};
export function Modal2({ children, trigger, ...dialogProps }: ModalProps) {
  return (
    <DialogTrigger>
      {trigger}

      <ModalBase {...dialogProps}>{children}</ModalBase>
    </DialogTrigger>
  );
}

type ControlledModalProps = DialogProps & ModalOverlayProps;
export function ModalControlled2({
  children,
  onOpenChange,
  isOpen,
  ...modalProps
}: ControlledModalProps) {
  return (
    <ModalOverlay2 onOpenChange={onOpenChange} isOpen={isOpen}>
      <AriaModal className={styles.modal}>
        <Dialog {...modalProps} className={cn(styles.dialog)}>
          {children}

          <CloseButton className={styles.close} slot="close" />
        </Dialog>
      </AriaModal>
    </ModalOverlay2>
  );
}

const styles = {
  modal: "aria-modal",
  dialog: [
    "aria-dialog",
    "tw:relative tw:min-w-120",
    "tw:bg-fill-white tw:rounded-lg tw:p-6 tw:shadow-2xl",
  ],
  close: "tw:absolute tw:top-1 tw:right-1 tw:z-1",
} as const;
